<template>
  <div>
    <Header v-on:setsearchdate="getTableDataByAPI"></Header>

    <section class="index_optbtn">
      <div class="operate_btn">
        <!--<a href="javascript:void(0)" @click="fullscreen()"><i class="iconfont icon-quanping"></i>Maximize</a>-->
        <div class="select_columns">
          <a href="javascript:void(0)" @click="selectDisplay()">Select columns<i
              class="iconfont icon-xiangxiajiantou1"></i></a>
          <div class="select_option" v-show="isShow == true" style="width: 255px;">
            <div style="max-height: 300px;overflow: auto;">
              <label class="option_item" v-for=" (v, key, index) in selectData" :for="key">
                <input type="checkbox" :id="key" :value="key" v-model="checkedNames" @change="handleClick" />{{ v }}
              </label>
            </div>
            <div class="footer_btn">
              <label class="option_item" style="margin-right: 10px;"><input type="checkbox" value="1"
                  v-model="isfullcheck" @change="clickfullcheck()" />{{ $t("indexbutton.selectall") }}</label>
              <a href="javascript:void(0)" @click="selectDisplay()">{{ $t("indexbutton.off") }}</a>
              <a href="javascript:void(0)" @click="saveDisplay()">{{ $t("indexbutton.save") }}</a>
            </div>
          </div>
        </div>
        <a href="javascript:void(0)" @click="selectdownload()">Download data<i class="iconfont icon-xiazai"></i></a>
      </div>
    </section>

    <section :class="{ fullscreen: isfullscreen }">
      <!-- <div style="display:none;">Checked names: {{ checkedNames }}</div> -->
      <div class="index_table">
        <table>
          <thead>
            <tr>
              <th width="55"><input type="checkbox" v-model="allchecked" @click="checkall()"></th>
              <th v-for=" (cv, ckey) in  checkedNames " :for="ckey" :style="'min-width:' + setwidths[ckey] + 'px;'+' cursor: pointer;'" >
                {{ selectData[cv] }}
                <span class="arrow asc" v-if="orderparam.indexOf(cv)!=-1&&(!evesortby[cv]?true:false)" @click="sortby(cv)"><img src="../assets/zd.png" width="20"> </span>
                <span class="arrow asc" v-if="orderparam.indexOf(cv)!=-1&&evesortby[cv]" @click="sortby(cv)"><img src="../assets/zk.png" width="20"> </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for=" (v, key) in list" :key="key" v-if="showpare(v)" :class="v.DisplayLevel == 2.0 ? 'collapse' : ''"
              :style="setstyle(v, key)">
              <td><input type="checkbox" :value="v['LDDBid']" v-model="rowselect[v['LDDBid']]" @change="checkchange(v)"/></td>
              <td v-for=" (cv, ckey) in checkedNames" :key="ckey">
                <router-link v-if='cv == "ProteinId"'
                  :to="{ path: '/description', query: { LDDBid: v.LDDBid, ProteinsCategoryId: v.ProteinsCategoryId } }">{{
                    v.ProteinId
                  }}</router-link>

                <div v-if='cv == "ProbeId"'>
                  <router-link :to="{ path: '/probe', query: { pid: v.ProbeId } }" target="_blank">
                    {{ v.ProbeId }}
                  </router-link>
                  <button v-if="v.DisplayLevel == 1 && v.ishow > 1" class="btn btn-primary" type="button"
                    data-toggle="collapse" @click="morechart(v.LDDBid, key)">{{
                      showname[key] ? showname[key] : '展开' }}</button>
                </div>
                <div v-if='cv == ""'>
                  <a href="javascript:void(0)" v-if='showwd(v.SitesList)'
                    @click="linkactive(v.LDDBid, v.Source, v.ProbeId,v.ProteinId)">Link</a>
                </div>

                <img v-if='cv == "ProbeStructImg"'
                  :src="v.ProbeStructImg && v.ProbeStructImg.val && v.ProbeStructImg.val != 'null' ? v.ProbeStructImg.val.url : ''"
                  class="indexsetimg" alt="Probe structure" />
                <div v-if='cv == "LigandId"'>
                  <!--<router-link :to="val != '-' ? '/competition?LigandId=' + val : '#'" v-for="(val, key1) in v.LigandId"
                    :key="key1">
                    {{ val }}
                  </router-link>-->
                  <a href="javascript:void(0)" v-for="(val, key1) in v.LigandId" @click="showLigandId(val)">
                    {{ val }}
                  </a>
                </div>
                <div v-if='cv == "CellLine"' v-html="resetVal(v.CellLine)"></div>
                <div v-if='cv == "Source"'>
                  <div v-for="(val, key1) in v.Source" :key="key1">
                    <a href="javascript:void(0)" @click="sourcesOpen(val)" @mouseenter="enter(val)" :title="showtitle">{{
                      val
                    }}</a>
                    
                    <br v-if="key1<v.Source.length-1">
                    <!--<br>-->
                  </div>
                </div>
                <div v-html="setlistValue(v, cv)" @click="showall($event)" style=""></div>
                <AppLink v-if='cv == "ProteinId"' :to="setrem(v, cv, '')" target="_blank">uniprot</AppLink>
                <AppLink v-if='cv == "ProteinId"' :to="setremAl(v, cv)" target="_blank">Alphafold</AppLink>
              </td>
            </tr>

          </tbody>
        </table>
        <div v-if="!list.length && isload" class="no-font">
          无靶点/位点数据
        </div>
        <div class="pagediv">
          <ul class="pagination">
            <li :class="page.pageNum <= 1 ? 'disabled' : ''" class="page-item" @click="prePage()"><a href="#">&laquo;</a>
            </li>
            <li :class="page.pageNum === index ? 'page-link active' : ''" v-for="index in  pageTotal "
              @click="curPage(index)"
              v-show="(index < 5 || pageTotal == index || (index >= page.pageNum && index <= page.pageNum + 4))">
              <a href="#" v-if="(index == page.pageNum && index > 5)"
                style=" color: #337ab7;background-color: #fff;border: 1px solid #ddd;"
                @dblclick="curPage(page.pageNum - 1)">...</a>
              <a href="#">{{ index }}</a>
              <a href="#" v-if="index == (page.pageNum + 4) && pageTotal != index"
                @click="curPage(page.pageNum + 1)">...</a>
            </li>
            <li :class="page.pageNum >= pageTotal ? 'disabled' : ''" class="page-item" @click="nextPage()"><a
                href="#">&raquo;</a></li>
            <li>
              <span>前往</span><input type="text" class="page_input" v-model="inputpage" @change="setpage()"><span>页</span>
            </li>
          </ul>

        </div>
      </div>
    </section>
    <div class="pop_bg" v-show="popBgShow" @click="closeAll()"></div>
    <div class="pop_apply_box" v-show="popShow" style="width: 420px;">
      <div class="header_info">
        <div class="title">{{ $t("button.Downloadselection") }}</div>
        <a href="javascript:void(0)" class="close_btn" @click="applyClose()">×</a>
      </div>
      <form>
        <dl class="formcolumn-item ">
          <dd class="formcolumn-item-ct radio_div">
            <div class="radio_bottom">
              <input type="radio" :placeholder="$t('button.Downloadselecteddata')" name="downloadtype" value=1 v-model="downloadtype"
                class="radio_download" style="width:17px;height:15px" /><label>{{ $t("button.Downloadselecteddata") }}</label>
              <br>
            </div>
            <div>
              <input type="radio" :placeholder="$t('button.Downloadalldata')" name="downloadtype" value=2 v-model="downloadtype"
                class="radio_download" style="width:17px;height:15px" /><label>{{ $t("button.Downloadalldata") }}</label>
            </div>
          </dd>
        </dl>
        <div class="footer_btn" style="width: 100px;    margin: auto;">
          <input type="button" :value="$t('button.Download')" @click="download()">
        </div>
      </form>
    </div>
    <div class="pop_data_sources" v-show="popSourcesShow">
      <div class="header_info">
        <div class="title">数据来源{{ syData.datacode }}</div>
        <a href="javascript:void(0)" class="close_btn" @click="sourcesClose()">×</a>
      </div>
      <h1>内容：</h1>
      <div class="sources_article">
        实验编号： {{ syData.experimentnumber }}<br>
        实验日期：{{ syData.implementationdate ? syData.implementationdate : "" }}<br>
        实验设计（模板）：<div v-html="syData.designexperiments"></div>
      </div>
    </div>
    <div class="pop_data_sources" v-show="popLigandShow">
      <div class="header_info">
        <div class="title">竞争配体名称：{{ LigandInf.name }}</div>
        <a href="javascript:void(0)" class="close_btn" @click="sourcesClose()">×</a>
      </div>
      <h1>内容：</h1>
      <div class="sources_article">
        其他名称： {{ LigandInf.OtherName }}<br>
        分子量：{{ LigandInf.MolecularWeight ? LigandInf.MolecularWeight : "" }}<br>
        结构图：
        <div v-html="setlisrc(LigandInf.ProbeStructurePic)" ></div>
      </div>
    </div>
    <div class="pop_apply_box" v-show="messageinfo" style="width: 420px;z-index: 200000;">
      <div class="header_info">
        <div class="title">消息</div>
      </div>
      <div class="sources_article message_box">
        {{ messagetext }}
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './header/Index.vue'
import Footer from './footer/Index.vue'
import api from './../axios/api.js'
import AppLink from './../components/AppLink.vue'
export default {
  components: {
    Header,
    Footer,
    AppLink
  },
  data() {
    return {
      isl:false,
      un:"",
      messagetext: "",
      messageinfo: false,
      tableData: [],
      checkedNames: [],
      isShow: false,
      isfullscreen: false,
      popBgShow: false,
      popShow: false,
      popSourcesShow: false,
      selectData: {

      },
      list: [],
      showpareArr: [],
      showname: [],
      syData: {},
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      pageTotal: 0,
      total: 0, // 当前条数
      param: {},
      rowselect: {
      },
      allchecked: null,
      listA: [],
      downloadtype: 1,
      selectdownloaddata:[],
      isarticle: false,
      inputpage: "",
      openkey: [],
      isfullcheck: "",
      showtitle: "",
      setwidths: [],
      seloption: [],
      isload: false,
      popLigandShow: false,
      LigandInf: {},
      ProteinIdsort:false,//false倒序，true正序
      arrName: [
        "KeggPathway",
        "KeggDrug",
        "WikiPath",
        "NetPath",
        "IntePath",
        "PantPath",
        "GoBp",
        "GoCc",
        "GoMf",
        "Disease",
        "CellularLocation",
        'CompetitiveRatio',
        'Density',
        'concentration',
        "DrugBankID",
        "DrugBankName",
        "DrugBankGroups",
        "IntramembraneInterval",
        "IntramembraneDescription",
        "IntramembraneEvidence",
        "TransmembraneInterval",
        "TransmembraneDescription",
        "TransmembraneEvidence",
        "DrugCrntralID",
        "DrugCrntralName",
        "TTDDrugID",
        "TTDDrugName",
        "TTDDrugGroup",
        "DomainCCDescription",
        "DomainCCEvidence",
        "DomainFTInterval",
        "DomainFTDescription",
        "DomainFTEvidence"
      ],
      "nolink": [
        "CompetitiveRatio",
        "Density",
        "concentration",
        "DrugBankName",
        "DrugBankGroups",
        "IntramembraneInterval",
        "IntramembraneDescription",
        "IntramembraneEvidence",
        "TransmembraneInterval",
        "TransmembraneDescription",
        "TransmembraneEvidence",
        "DomainFTInterval",
        "DomainFTDescription",
        "DomainFTEvidence",
        "DomainCCDescription",
        "DomainCCEvidence",
        "TTDDrugName",
        "TTDDrugGroup",
        //"DrugCrntralID",
        "DrugCrntralName"
      ],
      orderparam:["LDDBid","ProbeId","LigandId","CompetitiveRatio","Source","ProteinId","GeneNames","ProteinDescription","CellLine","EntryName","UniparcID","TddId","Density","concentration"],
      evesortby:{}
    }
  },
  created() {
    var searchCon1 = window.sessionStorage.getItem('searchCon');
    if (!searchCon1) this.getTableDataByAPI();
    this.getTabletitleByAPI();
  },

  methods: {
    sortby(val){
      var that=this;
      //A类排序
      if(val=="LDDBid"||val=="ProbeId"||val=="LigandId"||val=="CompetitiveRatio"||val=="Source"){
        that.list.sort(function(a,b){
          if(val=="LigandId"||val=="CompetitiveRatio"||val=="Source"){
           
            var dnum=b[val]&&b[val][0]!="-"?parseInt(b[val][0].replace("LDTP","").replace("LDPC","").replace("LDCM","").replace("LDRA","")):0;
            var anum=a[val]&&a[val][0]!="-"?parseInt(a[val][0].replace("LDTP","").replace("LDPC","").replace("LDCM","").replace("LDRA","")):0;
          }else{
            var dnum=b[val]?parseInt(b[val].replace("LDTP","").replace("LDPC","").replace("LDCM","")):0;
            var anum=a[val]?parseInt(a[val].replace("LDTP","").replace("LDPC","").replace("LDCM","")):0;
          }
          if(!that.evesortby[val]){
            return parseInt(anum)-parseInt(dnum);
          }else{
            return parseInt(dnum)-parseInt(anum)
          }
        });
        
        that.evesortby[val]=!that.evesortby[val];
        if(that.evesortby[val]==false){
          that.list.forEach(function(item,ind){
            if (item.DisplayLevel == 2) {
              var index = that.showpareArr.indexOf(val);
              if (index == -1) {
                var getfirstone=that.list.findIndex((t) => t.LDDBid==item.LDDBid&&t.DisplayLevel==1);
                if(getfirstone){
                  that.showpareArr.push(item.LDDBid);
                  that.openkey.push(getfirstone);
                  that.showname[getfirstone] = "收起";
                }
              }
            }
          })
        }
      }
      //B类排序
      if(val=="ProteinId"||val=="GeneNames"||val=="ProteinDescription"||val=="CellLine"||val=="EntryName"||val=="UniparcID"||val=="TddId"){
        var reA=/[^a-zA-Z]/g;
        var reN=/[^0-9]/g;
        
        that.list.sort(function(a,b){
            if(val=="CellLine"){
              var aA=a[val][0].replace(reA,"");
              var bA=b[val][0].replace(reA,"");
            }else{
              var aA=a[val].replace(reA,"");
              var bA=b[val].replace(reA,"");
            }

            
            if(!that.evesortby[val]){
              if(aA===bA){
                if(val=="CellLine"){
                  var aN=parseInt(a[val][0].replace(reN,""));
                  var bN=parseInt(b[val][0].replace(reN,""));
                }else{
                  var aN=parseInt(a[val].replace(reN,""));
                  var bN=parseInt(b[val].replace(reN,""));
                }

                return aN===bN ?0:aN>bN?1:-1;
              }else{
                return aA-bA?1:-1;
              }
              //return a.ProteinId.localeCompare(b.ProteinId,"zh-CN",{numeric:true});
            }else{
              if(aA===bA){
                if(val=="CellLine"){
                  var aN=parseInt(a[val][0].replace(reN,""));
                  var bN=parseInt(b[val][0].replace(reN,""));
                }else{
                  var aN=parseInt(a[val].replace(reN,""));
                  var bN=parseInt(b[val].replace(reN,""));
                }
                return aN===bN ?0:aN<bN?1:-1;
              }else{
                return bA-aA?1:-1;
              }
              //return b.ProteinId.localeCompare(a.ProteinId,"zh-CN",{numeric:true});
            }
            
          });
        if(that.evesortby[val]){
          that.evesortby[val]=false;
        }else{
          that.evesortby[val]=true;
        }
        /*if(that.evesortby[val]==false){
          that.list.forEach(function(item,ind){
            if (item.DisplayLevel == 2) {
              var index = that.showpareArr.indexOf(val);
              if (index != -1) {
              }else{
                that.showpareArr.push(item.LDDBid);
                that.openkey.push(ind);
                that.showname[ind] = "收起";
              }
            }
          })
        }*/
      }
      //C类排序
      if(val=="Density"||val=="concentration"){
        that.list.sort(function(a,b){
          
          if(!that.evesortby[val]){
            var wb=['uM','nM','mM'];
            var btext=b[val]?b[val][0]:"";
            var qbtext=btext.replace(/\d+/g, '');
            var dnum=wb.indexOf(qbtext);
            var atext=a[val]?a[val][0]:"";
            var qatext=atext.replace(/\d+/g, '');
            var anum=wb.indexOf(qatext);
            if(dnum==anum&&dnum!=-1){ 
              var aN=parseInt(atext.replace(wb[anum],""));
              var bN=parseInt(btext.replace(wb[anum],""));
              return aN===bN ?0:aN>bN?1:-1;
            }else{
              return anum-dnum?1:-1;
            }
          }else{
            var wb=['mM','nM','uM'];
            var btext=b[val]?b[val][0]:"";
            var dnum=wb.indexOf(btext);
            var atext=a[val]?a[val][0]:"";
            var anum=wb.indexOf(atext);
            if(dnum==anum&&dnum!=-1){
              var aN=parseInt(atext.replace(wb[anum],""));
              var bN=parseInt(btext.replace(wb[anum],""));
              return aN===bN ?0:aN<bN?1:-1;
            }else{
              return dnum-anum?1:-1;
            }
          }
          
        });
        
        that.evesortby[val]=!that.evesortby[val];
        /*if(that.evesortby[val]==false){
          that.list.forEach(function(item,ind){
            if (item.DisplayLevel == 2) {
              var index = that.showpareArr.indexOf(val);
              if (index != -1) {
              }else{
                that.showpareArr.push(item.LDDBid);
                that.openkey.push(ind);
                that.showname[ind] = "收起";
              }
            }
          })
        }*/
      }
    },
    checkchange(v){
      //单选事件
      var that=this;
      var checkone=that.rowselect[v.LDDBid];
      if(checkone){
        var result=that.list.filter((t) => t.LDDBid==v.LDDBid);
        result.forEach(function(val){
          var le=that.selectdownloaddata.filter((t) => t.LDDBid==val.LDDBid);
          if(!le.length) that.selectdownloaddata.push(val);
        });
      }
    },
    setlisrc(val) {
      var lihtml = "";
      if (val && val.val && val.val.url) lihtml = "<img src='" + val.val.url + "' alt='' height='200'>"
      return lihtml;
    },
    async showLigandId(val) {
      var that = this;
      var postdata = {
        "LigandId": val
      };
      var urllist = "/action/ebyeghlrgjlqpdlfr/getdata";
      api.getTableData(urllist, JSON.stringify(postdata)).then(res => {
        if (res.data && res.data.rows.length > 0) {
          that.LigandInf = res.data.rows[0];
          that.popLigandShow = true;
        }
      });
    },
    showwd(SitesList) {
      if (SitesList && SitesList.length > 0) {
        var isshow = false;
        SitesList.forEach(function (val) {
          if (val) {
            isshow = true;
          }
        })
        return isshow;
      }
    },
    linkactive(LDDBid, Source, ProbeId,ProteinId) {
      var that=this;
      let urllist = '/action/ejatglkvakzowpjax/linp';
      var yzform={
            username:that.un,
            isl:that.isl
        };
        api.getTableData(urllist, JSON.stringify(yzform)).then(res => {
          if (res.result == 1) {
            if(res.message=="无Link访问权限"){
              that.showInfo('无Link访问权限');
            }else{
              if (Source[0].indexOf('LDRA') != -1) {
                that.$router.push({ path: '/site', query: { LDDBid: LDDBid, ProbeId: ProbeId,ProteinId:ProteinId } });
              } else {
                var isLogined = localStorage.getItem("isLogined");
                if (!isLogined) {
                  that.showInfo('该功能仅限高级会员使用，请登录或联系我们');
                  return
                }
                that.$router.push({ path: '/site', query: { LDDBid: LDDBid, ProbeId: ProbeId,ProteinId:ProteinId } });
              }
            }
          }
        });

    },
    useryz(LDDBid, ProbeId) {
      this.$router.push({ path: '/click' })
    },
    handleClick() {
      var that = this;
      var selectedop = JSON.parse(JSON.stringify(that.checkedNames));
      that.checkedNames = [];
      that.setwidths = [];
      that.seloption.forEach(function (v) {
        if (!selectedop || !selectedop.length) {
          if (v.IsDefault == 1) {
            that.checkedNames.push(v.Field);
            that.setwidths.push(v.setwidth);
          }
        } else {
          if (selectedop.indexOf(v.Field) != -1) {
            that.checkedNames.push(v.Field);
            that.setwidths.push(v.setwidth);
          }
        }

      });
    },
    showall(e) {
      var morestyle = e.currentTarget.getElementsByClassName("more_text");
      if (morestyle.length > 0 && (morestyle[0].style.cssText == "display: none;")) {
        var getlite = e.currentTarget.firstElementChild.dataset.lite;
        $(e.currentTarget.firstElementChild).html(getlite);
        morestyle[0].style = "display:block;";
      } else {
        if (morestyle.length > 0 && (morestyle[0].style.cssText == "display: block;" || !morestyle[0].style.length)) {
          var gettext = e.currentTarget.firstElementChild.dataset.content;
          $(e.currentTarget.firstElementChild).html(gettext);
          morestyle[0].style = "display:none";
        }
      }
    },
    enter(val) {
      var that = this;
      if (val.indexOf('LDRA') != -1) {
        var postdata = {
          "datacode": val
        };
        var urllist = "/action/exettxhpoqalqpzer/getdata";
        postdata = {
          "articleid": val
        };
        api.getTableData(urllist, JSON.stringify(postdata)).then(res => {
          if (res.data && res.data.rows.length > 0) {
            that.syData = res.data.rows[0];
            that.showtitle = that.syData.essaydoi;
          }
        });
      }
      that.showtitle = "";
    },
    clickfullcheck() {
      if (!this.isfullcheck) {
        this.checkedNames = [];
        return;
      }

      for (let v in this.selectData) {
        let kindex = this.checkedNames.indexOf(v);
        if (kindex == -1) {
          this.checkedNames.push(v);
        }
      }
    },
    setstyle(val) {
      if (val.vindex % 2 == 0) {
        return "height:200px;background: #fff;";
      }
      return "height:200px;background: #f4f7fb;";
    },
    checkall() {
      var that = this;
      if (that.allchecked == true) {
        //that.rowselect = {};//清空当前数据
        that.list.forEach(function (v) {
          that.$set(that.rowselect, v['LDDBid'], false);
        });
      } else {
        that.list.forEach(function (v) {
          that.$set(that.rowselect, v['LDDBid'], true);
          var le=that.selectdownloaddata.filter((t) => t.LDDBid==v.LDDBid);
          that.selectdownloaddata.push(v);
        });
      }

    },
    setpage() {
      if (this.inputpage) {
        this.page.pageNum = parseInt(this.inputpage);
        this.getPatients(this.page.pageNum);
        this.inputpage = "";
      }
    },
    curPage(index) {
      this.getPatients(index);
    },
    prePage() {
      if (this.page.pageNum > 1) {
        this.getPatients(--this.page.pageNum);
      }
    },
    nextPage() {
      if (this.page.pageNum < this.pageTotal) {
        this.getPatients(++this.page.pageNum);
      }
    },
    getPatients(pageNum) {
      this.allchecked = null;
      //this.rowselect = {};
      this.page.pageNum = pageNum;
      this.getTableDataByAPI();
    },
    morechart(val, ind, e) {
      var index = this.showpareArr.indexOf(val);
      if (index != -1) {
        if (index > -1) {
          this.showname[ind] = "展开";
          this.showpareArr.splice(index, 1);
          this.openkey.splice(index, 1);
        }
      }else{
        this.showpareArr.push(val);
        this.openkey.push(ind);
        this.showname[ind] = "收起";
      }
    },
    showpare(val) {
      if (val) {
        if (val.DisplayLevel == 1) {
          return true;
        }
        if (this.showpareArr.indexOf(val.LDDBid) != -1 && val.DisplayLevel == 2) {
          return true;
        }
        return false;
      }
    },
    resetVal(val) {
      let newval = "";
      if (val == undefined) {
        return newval;
      }
      val.forEach(function (item) {
        var nval = "";
        if (item) {
          if (item.indexOf('LDCLL') != -1) {
            item = item.replace('LDCLL', '');
          }
          if (item.indexOf('LDCLC') != -1) {
            item = item.replace('LDCLC', '');
          }
          if (item.indexOf('LDCL') != -1) {
            item = item.replace('LDCL', '');
          }
          nval = item;
        }
        newval += nval + "<br>";
      })
      return newval;
    },
    setrem(v, cv) {
      var otherop = ["ProteinId"];
      if (otherop.indexOf(cv) != -1) {
        var url = "https://www.uniprot.org/uniprotkb/" + v[otherop] + "/entry";
        return url;
      }
      return "";
    },
    setremAl(v, cv) {
      var otherop = ["ProteinId"];
      if (otherop.indexOf(cv) != -1) {
        var url = "https://alphafold.ebi.ac.uk/entry/" + v[otherop];
        return url;
      }
      return "";
    },
    setSourceValue(item, value) {
      var rethtml = '';
      if (value == 0) {
        //文献
        if (item.References != null && item.References.lenght != 0) {
          for (var i = 0; i < item.References.length; i++) {
            if (rethtml.length > 0) {
              rethtml += "<br/>";
            }
            var url = item.References[i]["Url"];
            if (url != null && url != '') {
              rethtml += '<a href="' + url + '" target="_blank">' + item.References[i].No + '</a>';
            } else {
              rethtml += item.References[i].No;
            }
          }
        }
      } else {
        //实验记录
        rethtml = item.RecordNo;
      }
      return rethtml;
    },
    arrayformateVal(v, cv) {
      var ithtml = "";
      var showtext = "";
      var that = this;
      v[cv].forEach(function (item) {
        if ((cv == "KeggPathway" || cv == "GoBp" || cv == "GoCc" || cv == "GoMf") && item) {
          let no = item.No ? item.No : "";
          let Term = item.Term ? item.Term : "";
          var hrefset = "https://amigo.geneontology.org/amigo/medial_search?q=" + Term;
          if (cv == "KeggPathway") { hrefset = "https://www.kegg.jp/pathway/" + no; }
          showtext += no + ":" + Term;
          ithtml += '<a href="' + hrefset + '" target="_blank">' + no + ":" + Term + "</a><br>";
        }
        if (cv == "KeggDrug") {
          let KeggDrugId = item.KeggDrugId ? item.KeggDrugId : "";
          let Name = item.Name ? item.Name : "";
          showtext += KeggDrugId + ":" + Name;
          ithtml += '<a href="https://www.kegg.jp/kegg-bin/search?q=' + KeggDrugId + '&display=drug&from=drug" target="_blank">' + KeggDrugId + ":" + Name + "</a><br>";
        }
        if (cv == "Disease" && item.MimNo) {
          let Diseasem = item.Disease ? item.Disease : "";
          let MimNom = item.MimNo ? item.MimNo : "";
          let Descriptionm = item.Description ? item.Description : "";
          showtext += "DISEASE:" + Diseasem + "[" + MimNom + "]:" + Descriptionm;
          ithtml += "DISEASE:" + Diseasem + "[" + MimNom + "]:" + Descriptionm + "<br>";
        }
        if (cv == "CellularLocation" && item) {
          let Locationl = item.Location ? item.Location : "";
          let Evidancel = item.Evidance ? item.Evidance : "";
          if (Locationl || Evidancel) {
            showtext += Locationl + Evidancel;
            ithtml += Locationl + Evidancel + "<br>";
          }
        }
        if ((that.nolink.indexOf(cv) != -1) && item) {
          if (cv == "concentration" && item.indexOf('-') != -1) item = '-';
          showtext += item;
          ithtml += item + "<br>";
        }
        if (cv == "DrugBankID" && item) {
          showtext += item;
          ithtml += '<a href="https://go.drugbank.com/drugs/' + item + '" target="_blank">' + item + "</a><br>";
        }
        if (cv == "TTDDrugID" && item) {
          showtext += item;
          ithtml += '<a href="https://db.idrblab.net/ttd/data/drug/details/' + item + '" target="_blank">' + item + "</a><br>";
        }
        if (cv == "DrugCrntralID" && item) {
          showtext += item;
          ithtml += '<a href="https://drugcentral.org/target/'+item+'/view?q=' + item + '" target="_blank">' + item + "</a><br>";
        }
      });
      return { "ithtml": ithtml, "showtext": showtext };
    },
    createshowdiv(ithtml, lite) {
      var itdiv = $("<div data-content='' data-lite=''></div>");
      itdiv.attr("data-content", ithtml);
      itdiv.attr("data-lite", lite);
      itdiv.html(lite);
      ithtml = itdiv[0].outerHTML;
      ithtml += '<span class="more_text">[...]</span>';
      return ithtml;
    },
    setlistValue(v, cv, isdown = false) {
      var otherop = ["ProteinId", "ProbeId", "ProbeStructImg", "LabeledSitesdetail", "Source", "LigandId", "CellLine"];
      if (otherop.indexOf(cv) != -1) return "";
      //数据为数组的数据处理
      if (this.arrName.indexOf(cv) != -1) {
        var ithtml = "";
        if (!v[cv] || v[cv] == "-") { return ithtml; }//值为空时，直接返回此值
        if (typeof (v[cv]) == "string") { return v[cv]; }//值为字符串时，直接返回字符串
        var getval = this.arrayformateVal(v, cv);//获取数组数据转html内容;
        var showtext = getval['showtext'];//展示内容，用于隐藏展示使用
        ithtml = getval['ithtml'];//全部内容，用于隐藏展示是使用
        var newlen = ithtml ? ithtml.split('<br>') : '';
        //超过3行的或者展示数据大于200个字符的，进行截取操作
        if (newlen.length > 3 || showtext.length > 200) {
          var lite = newlen[0] + newlen[1];
          if (cv != "KeggDrug" && cv != "KeggPathway" && cv != "GoBp" && cv != "GoCc" && cv != "GoMf") {
            if (lite.length > 200) { lite = lite.substring(0, 200); }
          }
          //创建div,组合最终的html

          ithtml = this.createshowdiv(ithtml, lite);
          if (isdown) ithtml = showtext;
        }
        return ithtml;
      } else {
        //不为数组的数据处理
        var ithtml = v[cv];
        if (isdown) return ithtml;
        //字符串大于100个字符的，进行截取操作
        if (ithtml && ithtml.length > 100) {
          var lite = ithtml.substring(0, 100);
          if (cv == "ChEMBL") {
            lite = '<a href="https://www.ebi.ac.uk/chembl/target_report_card/' + lite + '" target="_blank">' + lite + '</a>';
          }
          if (cv == "TddId" && lite != "-") {
            lite = '<a href="https://db.idrblab.net/ttd/search/ttd/target?search_api_fulltext=' + lite + '" target="_blank">' + lite + "</a>";
          }
          //创建div,组合最终的html
          ithtml = this.createshowdiv(ithtml, lite);
        } else {
          if ((cv == "ChEMBL" || cv == "TddId" || cv == "BindingDB" || cv == "GuidetoPHARMACOLOGY") && ithtml) ithtml = ithtml.replace(';', '');
          if (cv == "ChEMBL" && ithtml) {
            ithtml = "<div>" + '<a href="https://www.ebi.ac.uk/chembl/target_report_card/' + ithtml + '" target="_blank">' + ithtml + "</a></div>";
          }
          if (cv == "TddId" && ithtml && ithtml != "-") {
            ithtml = "<div>" + '<a href="https://db.idrblab.net/ttd/search/ttd/target?search_api_fulltext=' + ithtml + '" target="_blank">' + ithtml + "</a></div>";
          }
          if (cv == "BindingDB" && ithtml) {
            ithtml = "<div>" + '<a href="https://www.bindingdb.org/rwd/jsp/dbsearch/PrimarySearch_ki.jsp?polymerid=50003665&tag=pol&target=UNIPROT:' + ithtml + '&accession_number=' + ithtml + '&submit=Search" target="_blank">' + ithtml + "</a></div>";
          }
          if (cv == "GuidetoPHARMACOLOGY" && ithtml) {
            ithtml = "<div>" + '<a href="https://www.guidetopharmacology.org/GRAC/ObjectDisplayForward?objectId=' + ithtml + '" target="_blank">' + ithtml + "</a></div>";
          }
        }
        return ithtml;
      }
    },
    selectDisplay() {
      if (this.isShow) {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    saveDisplay() {
      var that = this;
      if (that.isShow) {
        that.isShow = false;
      } else {
        that.isShow = true;
      }
      localStorage.setItem('selectedoption', JSON.stringify(that.checkedNames));
    },
    fullscreen() {
      if (this.isfullscreen) {
        this.isfullscreen = false;
      } else {
        this.isfullscreen = true;
      }
    },
    selectdownload() {
      this.popBgShow = true;
      this.popShow = true;
    },
    applyClose() {
      this.popBgShow = false;
      this.popShow = false;
    },
    sourcesOpen(val) {
      this.getdsjyData(val);
      if (!this.isarticle) {
        this.popBgShow = true;
        this.popSourcesShow = true;
      }

    },
    sourcesClose() {
      this.popBgShow = false;
      this.popSourcesShow = false;
      this.popLigandShow = false;
    },
    closeAll() {
      this.popBgShow = false;
      this.popSourcesShow = false;
      this.popShow = false;
    },
    async getTabletitleByAPI() {
      //查询列表头部名称
      let url = '/action/enwlnqvipoosmpuhu/getconfigcolumns';
      let that = this;
      let selectedop = JSON.parse(localStorage.getItem('selectedoption'));
      that.checkedNames = [];
      that.setwidths = [];
      await api.getTableData(url).then(res => {
        that.seloption = res.data;
        that.seloption.forEach(function (v) {
          if (v.IsDisplay) {
            if (v.Field == "") that.selectData[v.Field] = that.$t('indextitle[""]');
            else that.selectData[v.Field] = that.$t("indextitle." + v.Field);
            if (!selectedop || !selectedop.length) {
              if (v.IsDefault == 1) {
                that.checkedNames.push(v.Field);
                that.setwidths.push(v.setwidth);
              }
            } else {
              if (selectedop.indexOf(v.Field) != -1) {
                that.checkedNames.push(v.Field);
                that.setwidths.push(v.setwidth);
              }
            }
          }
        });
      });
    },
    async getTableDataByAPI(param) {
      //查询列表信息

      let that = this;
      that.isl = localStorage.getItem("isLogined");
      that.un= localStorage.getItem("username");
      if (param) {
        param = JSON.parse(param);
        that.param = param;
        param.page = that.page;
        param.page.pageNum = 1;
        param.isl=that.isl;
        param.un=that.un;
        param = JSON.stringify(param);
      } else {
        param = that.param;
        param.page = that.page;
        param.total = that.total;
        param.totalPages = that.pageTotal;
        param.isl=that.isl;
        param.un=that.un;
        param = JSON.stringify(param);
      }
      that.list = [];
      let urllist = '/action/etpdxwptrnxiwushd/searchdata';
      await api.getTableData(urllist, param).then(res => {
        if (res.data) {
          if (that.page.pageNum == 1) {
            that.pageTotal = res.data.param.totalPages;
            that.total = res.data.param.total;
            that.param.total = that.total;
            that.param.totalPages = that.pageTotal;
          }
          var yssdata = res.data.rows;
          
          yssdata.forEach(function (v, index) {
            var newval = v.ProbeId;
            newval.forEach(function (val, ind) {
              let onelist = JSON.parse(JSON.stringify(v));
              onelist['Density'] = v['Density'][val];
              onelist['concentration'] = v['concentration'][val];
              onelist['CompetitiveRatio'] = v['CompetitiveRatio'][val];
              onelist['LigandId'] = v['LigandId'][val];
              onelist['CellLine'] = v['CellLine'][val];
              onelist['Source'] = v['Source'][val];
              onelist['SitesList'] = v['SitesList'][val];
              onelist['ProbeId'] = val;
              onelist['ProbeType'] = v['ProbeType'][ind];
              onelist['DisplayLevel'] = 1;
              onelist['ProbeStructImg'] = v['ProbeStructImg'][ind];
              onelist['DrugBankID'] = [];
              onelist['DrugBankName'] = [];
              onelist['DrugBankGroups'] = [];
              if (v['DrugBank']) {
                v['DrugBank'].forEach(function (it) {
                  onelist['DrugBankID'].push(it['DrugBank']);
                  onelist['DrugBankName'].push(it['DrugName']);
                  onelist['DrugBankGroups'].push(it['Group']);
                })
              }
              delete v['DrugBank'];
              onelist['IntramembraneInterval'] = [];
              onelist['IntramembraneDescription'] = [];
              onelist['IntramembraneEvidence'] = [];
              if (v['Intramembrane']) {
                v['Intramembrane'].forEach(function (it) {
                  onelist['IntramembraneInterval'].push(it['Interval']);
                  onelist['IntramembraneDescription'].push(it['Description']);
                  onelist['IntramembraneEvidence'].push(it['Evidence']);
                })
              }
              delete v['Intramembrane'];
              onelist["TransmembraneInterval"] = [];
              onelist["TransmembraneDescription"] = [];
              onelist["TransmembraneEvidence"] = [];
              if (v['Transmembrane']) {
                v['Transmembrane'].forEach(function (it) {
                  onelist['TransmembraneInterval'].push(it['Interval']);
                  onelist['TransmembraneDescription'].push(it['Description']);
                  onelist['TransmembraneEvidence'].push(it['Evidence']);
                })
              }
              delete v['Transmembrane'];
              onelist["DrugCrntralID"] = [];
              onelist["DrugCrntralName"] = [];
              if (v['DrugCrntral']) {
                v['DrugCrntral'].forEach(function (it) {
                  onelist['DrugCrntralID'].push(it['DrugCrntralId']);
                  onelist['DrugCrntralName'].push(it['DrugName']);
                })
              }
              delete v['DrugCrntral'];
              onelist["TTDDrugID"] = [];
              onelist["TTDDrugName"] = [];
              onelist["TTDDrugGroup"] = [];
              if (v['TTDDrug']) {
                v['TTDDrug'].forEach(function (it) {
                  onelist['TTDDrugID'].push(it['ID']);
                  onelist['TTDDrugName'].push(it['Name']);
                  onelist['TTDDrugGroup'].push(it['Group']);
                })
              }
              delete v['TTDDrug'];
              onelist["DomainCCDescription"] = [];
              onelist["DomainCCEvidence"] = [];
              if (v['DomainCC']) {
                v['DomainCC'].forEach(function (it) {
                  onelist['DomainCCDescription'].push(it['Description']);
                  onelist['DomainCCEvidence'].push(it['Evidence']);
                })
              }
              delete v['DomainCC'];
              onelist["DomainFTInterval"] = [];
              onelist["DomainFTDescription"] = [];
              onelist["DomainFTEvidence"] = [];
              if (v['DomainFT']) {
                v['DomainFT'].forEach(function (it) {
                  onelist['DomainFTInterval'].push(it['Interval']);
                  onelist['DomainFTDescription'].push(it['Description']);
                  onelist['DomainFTEvidence'].push(it['Evidence']);
                })
              }
              delete v['DomainFT'];
              onelist['ishow'] = newval.length;
              onelist['vindex'] = index;
              if (ind > 0) {
                onelist['DisplayLevel'] = 2;
              }
              let ispush = false;
              if (!that.param.seatype && !that.param.allsearch) ispush = true;
              if (that.param.seatype && that.param.content) {
                var ProbeOIds = that.param.content['$and'][0]['ProbeOId']['$in'];
                if (ProbeOIds.indexOf(onelist['ProbeOId'][ind]) != -1) { ispush = true; }
              }
              if (that.param.allsearch) {
                that.param.allsearch.forEach(function (s) {
                  let ProteinId = onelist['ProteinId'] ? onelist['ProteinId'] : '';
                  let LDDBid = onelist['LDDBid'] ? onelist['LDDBid'] : '';
                  let Species = onelist['Species'] ? onelist['Species'] : '';
                  let ProteinDescription = onelist['ProteinDescription'] ? onelist['ProteinDescription'] : '';
                  let GeneNames = onelist['GeneNames'] ? onelist['GeneNames'] : '';
                  let ProbeId = onelist['ProbeId'] ? onelist['ProbeId'] : '';
                  let ProbeType = onelist['ProbeType'] ? onelist['ProbeType'] : '';
                  let SitesList = onelist['SitesList'] ? onelist['SitesList'] : '';
                  let Density = onelist['Density'] ? onelist['Density'] : '';
                  let CompetitiveRatio = onelist['CompetitiveRatio'] ? onelist['CompetitiveRatio'] : '';
                  let LigandId = onelist['LigandId'] ? onelist['LigandId'] : '';
                  let Source = onelist['Source'] ? onelist['Source'] : '';
                  let TargType = onelist['TargType'] ? onelist['TargType'] : '';
                  let DrugBankGroups = onelist['DrugBankGroups'] ? onelist['DrugBankGroups'] : '';
                  let TargetHierarchy = onelist['TargetHierarchy'] ? onelist['TargetHierarchy'] : '';
                  let KeggDrug = onelist['KeggDrug'] ? onelist['KeggDrug'] : '';
                  if(KeggDrug){
                    KeggDrug=KeggDrug.map(t=>t.Name);
                    KeggDrug=KeggDrug.join(',');
                  }
                  if (s.notcheck) {
                    if (s.key == "ALL") {
                      if (ProteinId.indexOf(s.val) == -1
                        && Species.indexOf(s.val) == -1
                        && ProteinDescription.indexOf(s.val) == -1
                        && GeneNames.indexOf(s.val) == -1
                        && ProbeId.indexOf(s.val) == -1
                        && ProbeType.indexOf(s.val) == -1
                        && SitesList.indexOf(s.val) == -1
                        && Density.indexOf(s.val) == -1
                        && CompetitiveRatio.indexOf(s.val) == -1
                        && LigandId.indexOf(s.val) == -1
                        && Source.indexOf(s.val) == -1
                        && LDDBid.indexOf(s.val) == -1
                        && TargType.indexOf(s.val) == -1
                        && TargetHierarchy.indexOf(s.val) == -1
                        && KeggDrug.indexOf(s.val) == -1
                      ) {
                        ispush = true;
                        return;
                      }
                    }
                    if (onelist[s.key] && onelist[s.key].indexOf(s.val) == -1) ispush = true;
                    return;
                  }
                  if (s.key == "ALL") {
                    if (ProteinId.indexOf(s.val) != -1
                      || Species.indexOf(s.val) != -1
                      || ProteinDescription.indexOf(s.val) != -1
                      || GeneNames.indexOf(s.val) != -1
                      || ProbeId.indexOf(s.val) != -1
                      || ProbeType.indexOf(s.val) != -1
                      || SitesList.indexOf(s.val) != -1
                      || Density.indexOf(s.val) != -1
                      || CompetitiveRatio.indexOf(s.val) != -1
                      || LigandId.indexOf(s.val) != -1
                      || Source.indexOf(s.val) != -1
                      || LDDBid.indexOf(s.val) != -1
                      || TargType.indexOf(s.val) != -1
                      || DrugBankGroups.indexOf(s.val) != -1
                      || TargetHierarchy.indexOf(s.val) != -1
                      || KeggDrug.indexOf(s.val) != -1
                    ) {
                      ispush = true;
                      return;
                    }
                  }
                  if (onelist[s.key] && onelist[s.key].indexOf(s.val) != -1) ispush = true;
                })
              }

              if (ispush) {
                if (that.param.seatype || that.param.allsearch) {
                  onelist['DisplayLevel'] = 1;
                  onelist['ishow'] = 1;
                }
                that.list.push(onelist);
              }
            })
          });
          
          that.isload = true;
        }
      });
    },
    async getdsjyData(val) {
      //查询数据源
      var that = this;
      var postdata = {
        "datacode": val
      };
      let urllist = '/action/egxqivukrqpdlzsjz/getdata';
      that.isarticle = false;
      if (val.indexOf('LDRA') != -1) {
        urllist = "/action/exettxhpoqalqpzer/getdata";
        postdata = {
          "articleid": val
        };
        that.isarticle = true;
      }
      await api.getTableData(urllist, JSON.stringify(postdata)).then(res => {
        if (res.data && res.data.rows.length > 0) {
          that.syData = res.data.rows[0];
          if (that.isarticle) {
            window.open(that.syData.essayurl);
          }

        }
      });
    },
    async download() {
      let that = this;
      let downloaddata = [];
      let downchoese = {};
      
      if (that.downloadtype == 1) {
        //下载选中数据
        let Alldata = this.selectdownloaddata;
        Alldata.forEach((list) => {
          let newrow = {};
          this.checkedNames.forEach((row) => {
            if(row!="ProbeStructImg"){
              var newval = "";
              var arrField = ["LigandId", "Source", "DrugBankID", 'DrugBankName', 'DrugBankGroups', 'IntramembraneInterval', 'IntramembraneDescription', 'IntramembraneEvidence', 'TransmembraneInterval', 'TransmembraneDescription', 'TransmembraneEvidence', 'DrugCrntralID', 'DrugCrntralName', 'TTDDrugID', 'TTDDrugName', 'TTDDrugGroup', 'DomainCCDescription', 'DomainCCEvidence', 'DomainFTInterval', 'DomainFTDescription', 'DomainFTEvidence'];//数组处理
              var imageField = ["ProbeStructImg"];//图片处理
              var syField = ["CellLine"];//实验数据，截取前缀处理
              var otherop = ["LDDBid", "ProbeId", "LabeledSitesdetail", "Source", 'ProteinId', "ChEMBL", "TddId", "BindingDB", "GuidetoPHARMACOLOGY"];//不处理数据
              if (syField.indexOf(row) != -1) {
                newval = this.resetVal(list['CellLine']);
              } else if (arrField.indexOf(row) != -1) {
                newval = list[row];
                if (newval) newval = newval.join('<br>');
              } else if (imageField.indexOf(row) != -1) {
                newval = list[row];
                if (newval.val) newval = newval.val['url'];
              } else if (otherop.indexOf(row) != -1) {
                newval = list[row];
              } else {
                newval = this.downloadsetlistValue(list, row, true);
              }
              if (newval) {
                newval = newval.replaceAll("<br>", '\n');
              }
              var keyname = this.selectData[row];
              if (row) newrow[keyname] = newval;
            }

          });
          if (this.rowselect[list['LDDBid']]) {
            delete newrow['_id'];
            downloaddata.push(newrow);
          }
        });
        if (!downloaddata.length) {
          var tinfo=this.$t('indexwarn.downwarn');
          that.showInfo(tinfo)
          return;
        }
      } else {
        //下载全部选中数据
        downchoese = that.param;
      }
      this.closeAll();

      this.messageinfo = true;
      this.messagetext = "正在下载，请稍等...";
      let urllist = '/action/etpdxwptrnxiwushd/download';
      var downparam={ 
        dwdata: downloaddata,
        downchoese: downchoese,
        checkedNames: this.checkedNames,
        selectData: that.selectData,
        isl: that.isl,
        un: that.un
      };
      await api.getTableData(urllist, JSON.stringify(downparam)).then(res => {
        that.messagetext = "下载完成";
        if (res.data) {
          var filename = res.data.name;
          var preurl="https://adminprobe.leadartech.cn/openapi/utils/downexcel?file=";
          var url = preurl + filename;
          window.open(url);
        }else{
          this.showInfo(res.message);
        }
        that.messageinfo = false;
      });
    },
    downloadsetlistValue(v, cv, isdown = false) {
      var otherop = ["ProteinId", "ProbeId", "ProbeStructImg", "LabeledSitesdetail", "Source", "LigandId", "CellLine"];
      if (otherop.indexOf(cv) != -1) return "";
      //数据为数组的数据处理
      if (this.arrName.indexOf(cv) != -1) {
        var ithtml = "";
        if (!v[cv] || v[cv] == "-") { return ithtml; }//值为空时，直接返回此值
        if (typeof (v[cv]) == "string") { return v[cv]; }//值为字符串时，直接返回字符串
        var getval = this.downloadarrayformateVal(v, cv);//获取数组数据转html内容;
        var showtext = getval['showtext'];//展示内容，用于隐藏展示使用
        ithtml = getval['ithtml'];//全部内容，用于隐藏展示是使用
        var newlen = ithtml ? ithtml.split('<br>') : '';
        //超过3行的或者展示数据大于200个字符的，进行截取操作
        if (newlen.length > 3 || showtext.length > 200) {
          var lite = newlen[0] + newlen[1];
          if (cv != "KeggDrug" && cv != "KeggPathway" && cv != "GoBp" && cv != "GoCc" && cv != "GoMf") {
            if (lite.length > 200) { lite = lite.substring(0, 200); }
          }
          //创建div,组合最终的html

          ithtml = ithtml;
          if (isdown) ithtml = showtext;
        }
        return ithtml;
      } else {
        //不为数组的数据处理
        var ithtml = v[cv];
        if (isdown) return ithtml;
        //字符串大于100个字符的，进行截取操作
        if (ithtml && ithtml.length > 100) {
          var lite = ithtml.substring(0, 100);
          if (cv == "ChEMBL") {
            lite =  lite;
          }
          if (cv == "TddId" && lite != "-") {
            lite =  lite ;
          }
          //创建div,组合最终的html
          ithtml =ithtml;
        } else {
          if ((cv == "ChEMBL" || cv == "TddId" || cv == "BindingDB" || cv == "GuidetoPHARMACOLOGY") && ithtml) ithtml = ithtml.replace(';', '');
          if (cv == "ChEMBL" && ithtml) {
            ithtml = ithtml;
          }
          if (cv == "TddId" && ithtml && ithtml != "-") {
            ithtml =  ithtml;
          }
          if (cv == "BindingDB" && ithtml) {
            ithtml = ithtml ;
          }
          if (cv == "GuidetoPHARMACOLOGY" && ithtml) {
            ithtml = ithtml;
          }
        }
        return ithtml;
      }
    },
    downloadarrayformateVal(v, cv) {
      var ithtml = "";
      var showtext = "";
      var that = this;
      v[cv].forEach(function (item) {
        if ((cv == "KeggPathway" || cv == "GoBp" || cv == "GoCc" || cv == "GoMf") && item) {
          let no = item.No ? item.No : "";
          let Term = item.Term ? item.Term : "";
          var hrefset = "https://amigo.geneontology.org/amigo/medial_search?q=" + Term;
          if (cv == "KeggPathway") { hrefset = "https://www.kegg.jp/pathway/" + no; }
          showtext += no + ":" + Term;
          ithtml += no + ":" + Term;
        }
        if (cv == "KeggDrug") {
          let KeggDrugId = item.KeggDrugId ? item.KeggDrugId : "";
          let Name = item.Name ? item.Name : "";
          showtext += KeggDrugId + ":" + Name;
          ithtml +=  KeggDrugId + ":" + Name ;
        }
        if (cv == "Disease" && item.MimNo) {
          let Diseasem = item.Disease ? item.Disease : "";
          let MimNom = item.MimNo ? item.MimNo : "";
          let Descriptionm = item.Description ? item.Description : "";
          showtext += "DISEASE:" + Diseasem + "[" + MimNom + "]:" + Descriptionm;
          ithtml += "DISEASE:" + Diseasem + "[" + MimNom + "]:" + Descriptionm + " \n";
        }
        if (cv == "CellularLocation" && item) {
          let Locationl = item.Location ? item.Location : "";
          let Evidancel = item.Evidance ? item.Evidance : "";
          if (Locationl || Evidancel) {
            showtext += Locationl + Evidancel;
            ithtml += Locationl + Evidancel + " \n";
          }
        }
        if ((that.nolink.indexOf(cv) != -1) && item) {
          if (cv == "concentration" && item.indexOf('-') != -1) item = '-';
          showtext += item;
          ithtml += item + " \n";
        }
        if (cv == "DrugBankID" && item) {
          showtext += item;
          ithtml +=  item + " \n";
        }
        if (cv == "TTDDrugID" && item) {
          showtext += item;
          ithtml += item + " \n";
        }
        if (cv == "DrugCrntralID" && item) {
          showtext += item;
          ithtml +=  item + " \n";
        }
      });
      return { "ithtml": ithtml, "showtext": showtext };
    },
    showInfo(val) {
      toastr.info(val, this.$t('indexwarn.downwarntitle'), {
        closeButton: true,
        progressBar: true,
        newestOnTop: true,
        positionClass: "toast-top-center"
      });
      return;
    }
  }
}
</script>

<style>
.pagediv {
  position: fixed;
  left: 0;
  bottom: 88px;
  width: 100%;
  z-index: 10;
}

.footer_copyright {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 88px;
  z-index: -1;
  padding: 0 15px;
}

section .index_table {
  padding-bottom: 150px;
}

section .index_table table tbody tr td:first-child {
  min-width: auto;
}

.btn-primary {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

#complex_3d {
  width: 100%;
  height: 700px;
  position: relative;
}

.radio_download {
  width: auto;
  height: 17px;
  margin: 5px;
  line-height: 17px;
  vertical-align: middle;
}

.radio_div {
  font-size: 16px;
  text-align: center;
}

.radio_bottom {
  margin-bottom: 10px;
}

.page_input {
  position: relative;
  float: left;
  padding: 5px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
  width: 40px;
}

.othermore {
  color: #337ab7;
  text-decoration: none;
  background-color: #fff;
  border: 1px solid #ddd;
}


.show_text {
  -webkit-line-clamp: "unset"
}

.message_box {
  text-align: center;
  line-height: middle;
  line-height: 80px;
  font-size: 19px;
}

.no-font {
  text-align: center;
  line-height: 82px;
  color: white;
  font-size: 16px;
}

.arrow {
  display:inline-block;
  vertical-align:middle;
  width:0;
  opacity:0.66;
}

.arrow.asc {
  border-right:15px solid transparent;
  border-bottom:4px solid transparent;
}

.arrow.desc {
  border-right:15px solid transparent;
  border-top:4px solid transparent;
}
</style>




// WEBPACK FOOTER //
// src/views/Index.vue